module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_500000_1000000.f50acef7.png";